import { render } from "./NowShowing.vue?vue&type=template&id=9a869bc2&ts=true"
import script from "./NowShowing.vue?vue&type=script&lang=ts"
export * from "./NowShowing.vue?vue&type=script&lang=ts"

import "./NowShowing.vue?vue&type=style&index=0&id=9a869bc2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__